module.exports = __webpack_public_path__ + "static/media/staff.c4286b81.png";